import { defaultSetter }           from 'rewire-common';
import { capitalCase }             from 'change-case';
import DataQueries                 from '../graphql/Queries';
import reasonDialogModel           from '../schedule/ReasonDialogModel';
import { DefaultSchema }           from './SettingsModel';
import mainPageModel               from '../main-navigation/MainPageModel';
import { MasterDataSettingsModel } from './MasterDataSettingsModel';
import { ReasonSort }              from '../DataTypes';

const ReasonSchema = `
  ${DefaultSchema}
  category
  archived
`;

export default class ReasonsSettingsModel extends MasterDataSettingsModel {
  constructor() {
    super('Reason', 'reasons', reasonDialogModel, [
      { label: 'Category', get: (v: any) => v.category && capitalCase(v.category), set: defaultSetter('category') }
    ]);
  }

  get _canAddItem(): boolean {
    return mainPageModel.canAddReasons;
  }

  get _canEditItem(): boolean {
    return mainPageModel.canEditReasons;
  }

  get _canDeleteItem(): boolean {
    return mainPageModel.canDeleteReasons;
  }

  getOtherSortMenuItems(): {name: string, title: string}[] {
    return [
      {name: 'category', title: 'Category'}
    ];
  }

  protected async _load(filter: {search?: string}, sort?: ReasonSort) {
    const results = (await DataQueries.getReasons(ReasonSchema, filter, sort, this.paging.itemsPerPage, this.paging.currentPage));
    this.setItems(results.data);
    return results;
  }
}
